namespace GeniuzPOS.CustomReport {
    export class ReportCustomerSurveyColumns {
        static columnsKey = 'CustomReport.ReportCustomerSurvey';
    }
}
